// Mock data for MAG Protection website.
// Text content is translated via LanguageContext - mock.js only holds
// structural data (ids, images, phone numbers, etc.) and the translation key.

export const services = [
  { id: 1, key: "eventSecurity", image: "/securite-evenementielle.jpg" },
  { id: 2, key: "guarding", image: "https://images.unsplash.com/photo-1485230405346-71acb9518d9c" },
  { id: 3, key: "closeProtection", image: "https://images.unsplash.com/photo-1618371731836-2b9bff9ac72a" },
  { id: 4, key: "patrols", image: "https://images.unsplash.com/photo-1652739758426-56a564265f9e" },
  { id: 5, key: "nightSurveillance", image: "https://images.pexels.com/photos/11085913/pexels-photo-11085913.jpeg" },
  { id: 6, key: "constructionSite", image: "/securite-chantier.jpg" },
  { id: 7, key: "steward", image: "/steward-securite.jpg" },
  { id: 8, key: "secureTransport", image: "/transport-securise-vip.jpg" },
  { id: 9, key: "cameraInstall", image: "https://images.unsplash.com/photo-1643123182527-3bd30840e7ed" },
  { id: 10, key: "accessControl", image: "/controle-acces.jpg" },
  { id: 11, key: "k9", image: "/maitre-chien.jpg" },
  { id: 12, key: "remoteMonitoring", image: "/telesurveillance.jpg" }
];

export const stats = [
  { id: 1, value: "+500", key: "missions" },
  { id: 2, value: "+10", key: "experience" },
  { id: 3, value: "24/7", key: "availability" },
  { id: 4, value: "+200", key: "clients" }
];

export const testimonials = [
  { id: 1, key: "thomas", name: "Thomas M.", initials: "TM" },
  { id: 2, key: "sophie", name: "Sophie L.", initials: "SL" },
  { id: 3, key: "jean", name: "Jean-Pierre K.", initials: "JK" }
];

export const partners = [
  { id: 1, name: "Belval Plaza" },
  { id: 2, name: "BGL Ligue" },
  { id: 3, name: "ArcelorMittal" },
  { id: 4, name: "CFL" },
  { id: 5, name: "POST Luxembourg" },
  { id: 6, name: "Cactus" }
];

export const navItems = [
  { key: "about", href: "#about" },
  { key: "services", href: "#services" },
  { key: "partners", href: "#partners" },
  { key: "contact", href: "#contact" }
];

export const contactInfo = {
  phones: ["+352 661 522 484", "+49 172 6382 787"],
  email: "mike@magprotection.lu"
};
